// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_1a0DG","tabColorHeader":"tabColorHeader_24Yo6","fromContainer":"fromContainer_2AUnp"};